export function tokenAmountFromProxy(proxy) {
    return { ...proxy, amount: BigInt(proxy.amount) };
}
export function tokenAmountToProxy(tokenAmount) {
    return {
        ...tokenAmount,
        amount: tokenAmount.amount.toString()
    };
}
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoidG9rZW5BbW91bnQuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi8uLi9zcmMvZXJnby9lbnRpdGllcy90b2tlbkFtb3VudC50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFnQkEsTUFBTSxVQUFVLG9CQUFvQixDQUFDLEtBQXVCO0lBQzFELE9BQU8sRUFBQyxHQUFHLEtBQUssRUFBRSxNQUFNLEVBQUUsTUFBTSxDQUFDLEtBQUssQ0FBQyxNQUFNLENBQUMsRUFBQyxDQUFBO0FBQ2pELENBQUM7QUFFRCxNQUFNLFVBQVUsa0JBQWtCLENBQUMsV0FBd0I7SUFDekQsT0FBTztRQUNMLEdBQUcsV0FBVztRQUNkLE1BQU0sRUFBRSxXQUFXLENBQUMsTUFBTSxDQUFDLFFBQVEsRUFBRTtLQUN0QyxDQUFBO0FBQ0gsQ0FBQyJ9